var _rect, _rect2, _rect3, _rect4, _circle, _circle2, _circle3, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _circle4, _circle5, _circle6, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _circle7, _circle8, _circle9, _rect19, _rect20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSterlingReviewArchitectureBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 220 180",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 24,
    width: 48,
    height: 132,
    rx: 6,
    stroke: "#219BE4",
    strokeWidth: 2.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 38,
    width: 28,
    height: 8,
    rx: 2,
    stroke: "#219BE4",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 54,
    width: 28,
    height: 8,
    rx: 2,
    stroke: "#219BE4",
    strokeWidth: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 70,
    width: 28,
    height: 8,
    rx: 2,
    stroke: "#219BE4",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 94,
    r: 3,
    stroke: "#219BE4",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 94,
    r: 3,
    stroke: "#219BE4",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 94,
    r: 3,
    stroke: "#219BE4",
    strokeWidth: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 108,
    width: 28,
    height: 8,
    rx: 2,
    stroke: "#219BE4",
    strokeWidth: 1.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 124,
    width: 28,
    height: 8,
    rx: 2,
    stroke: "#219BE4",
    strokeWidth: 1.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 8,
    width: 48,
    height: 148,
    rx: 6,
    stroke: "#219BE4",
    strokeWidth: 2.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 22,
    width: 28,
    height: 8,
    rx: 2,
    stroke: "#219BE4",
    strokeWidth: 1.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 38,
    width: 28,
    height: 8,
    rx: 2,
    stroke: "#219BE4",
    strokeWidth: 1.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 54,
    width: 28,
    height: 8,
    rx: 2,
    stroke: "#219BE4",
    strokeWidth: 1.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 70,
    width: 28,
    height: 8,
    rx: 2,
    stroke: "#219BE4",
    strokeWidth: 1.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 102,
    cy: 90,
    r: 3,
    stroke: "#219BE4",
    strokeWidth: 1.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 90,
    r: 3,
    stroke: "#219BE4",
    strokeWidth: 1.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 90,
    r: 3,
    stroke: "#219BE4",
    strokeWidth: 1.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 104,
    width: 28,
    height: 8,
    rx: 2,
    stroke: "#219BE4",
    strokeWidth: 1.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 120,
    width: 28,
    height: 8,
    rx: 2,
    stroke: "#219BE4",
    strokeWidth: 1.5
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 136,
    width: 28,
    height: 8,
    rx: 2,
    stroke: "#219BE4",
    strokeWidth: 1.5
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 40,
    width: 48,
    height: 116,
    rx: 6,
    stroke: "#219BE4",
    strokeWidth: 2.5
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 54,
    width: 28,
    height: 8,
    rx: 2,
    stroke: "#219BE4",
    strokeWidth: 1.5
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 70,
    width: 28,
    height: 8,
    rx: 2,
    stroke: "#219BE4",
    strokeWidth: 1.5
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 86,
    width: 28,
    height: 8,
    rx: 2,
    stroke: "#219BE4",
    strokeWidth: 1.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 106,
    r: 3,
    stroke: "#219BE4",
    strokeWidth: 1.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 106,
    r: 3,
    stroke: "#219BE4",
    strokeWidth: 1.5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 106,
    r: 3,
    stroke: "#219BE4",
    strokeWidth: 1.5
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 120,
    width: 28,
    height: 8,
    rx: 2,
    stroke: "#219BE4",
    strokeWidth: 1.5
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 136,
    width: 28,
    height: 8,
    rx: 2,
    stroke: "#219BE4",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSterlingReviewArchitectureBg);
export default __webpack_public_path__ + "static/media/sterling-review-architecture-bg.4a01bf8af0ab50fbfcbe4b4126593161.svg";
export { ForwardRef as ReactComponent };